import { Box, Button, IconButton, Tooltip } from '@mui/material';
import { useState } from 'react'
import CustomDialog from '../dialogs/CustomDialog';
import { useApproveTeamInvitationRequest } from '../../hooks/useTeamInvitations';
import CustomButton from 'components/buttons/CustomButton/CustomButton';
import { colors } from 'styles/colors';
import CheckIcon from 'icons/CheckIcon';
import { snackbarService } from 'services/snackbarService';

interface Props {
  id: string;
  refetch?: () => void;
}

function ApproveTeamRequestActionButton({ id, refetch }: Props) {
  const [open, setOpen] = useState<boolean>(false);

  const { mutate: approveRequest, isLoading } = useApproveTeamInvitationRequest(
    () => {
      setOpen(false);
      snackbarService.showSnackbar('Request has been approved successfully', 'success');
      refetch?.();
    },
    (error: any) => {
      setOpen(false);
      snackbarService.showSnackbar(error?.response?.data?.message ?? error?.message, 'error');
    },
  );

  const handleAccept = () => {
    approveRequest(id);
  }

  return (
    <>
      <Tooltip title={'Approve'}>
        <IconButton
          onClick={() => setOpen(true)}
          sx={{
            width: 25,
            height: 25,
            backgroundColor: colors.success,
            borderRadius: '4px',
            padding: 0,
            '&:hover': {
              backgroundColor: colors.success,
            },
          }}
        >
          <CheckIcon size={15} color={'white'} />
        </IconButton>
      </Tooltip>
      <CustomDialog
        open={open}
        title='Approve request'
        message={`Are you sure you want to approve this request?`}
        buttons={[
          <CustomButton
            key='cancel'
            text="Cancel"
            variant='outlined'
            color='primary'
            onClick={() => setOpen(false)}
            disabled={isLoading}
          />,
          <CustomButton
            key='approve'
            text="Approve"
            color='primary'
            onClick={handleAccept}
            loading={isLoading}
          />
        ]}
      />
    </>
  )
}

export default ApproveTeamRequestActionButton